import {
  ListBulleted,
  ListNumbered,
  TextBold,
  TextHeading,
  TextItalic,
  TextStrikethrough,
  TextType,
  TextUnderline,
} from '@mint-lib/icons';
import { cva } from 'class-variance-authority';

export const LIST_TYPES = ['numbered-list', 'bulleted-list'];

export enum TextStyle {
  heading1 = 'style_heading1',
  heading2 = 'style_heading2',
  normal = 'style_normal',
  numbered = 'numbered-list',
  bulleted = 'bulleted-list',
}

export const TextStylesLabelMap = {
  [TextStyle.heading1]: 'Heading 1',
  [TextStyle.heading2]: 'Heading 2',
  [TextStyle.normal]: 'Normal',
  [TextStyle.numbered]: 'Numbered List',
  [TextStyle.bulleted]: 'Bulleted List',
};

export const TextStylesList = [
  {
    value: TextStyle.normal,
    label: TextStylesLabelMap[TextStyle.normal],
    startAdornment: <TextType />,
  },
  {
    value: TextStyle.heading1,
    label: TextStylesLabelMap[TextStyle.heading1],
    startAdornment: <TextHeading />,
  },
  {
    value: TextStyle.heading2,
    label: TextStylesLabelMap[TextStyle.heading2],
    startAdornment: <TextHeading />,
  },
  {
    value: TextStyle.numbered,
    label: TextStylesLabelMap[TextStyle.numbered],
    startAdornment: <ListNumbered />,
  },
  {
    value: TextStyle.bulleted,
    label: TextStylesLabelMap[TextStyle.bulleted],
    startAdornment: <ListBulleted />,
  },
];
export const editorControlButtons = [
  {
    role: 'markButton',
    value: 'bold',
    icon: <TextBold />,
  },
  {
    role: 'markButton',
    value: 'italic',
    icon: <TextItalic />,
  },
  {
    role: 'markButton',
    value: 'underline',
    icon: <TextUnderline />,
  },
  {
    role: 'markButton',
    value: 'linethrough',
    icon: <TextStrikethrough />,
  },
  {
    role: 'blockButton',
    value: 'bulleted-list',
    icon: <ListBulleted />,
  },

  {
    role: 'blockButton',
    value: 'numbered-list',
    icon: <ListNumbered />,
  },
];

export const editorVariants = cva(
  'h-full min-h-20 w-full min-w-108 rounded-sm bg-ui-field02 px-3 py-2 leading-normal text-text-primary read-only:bg-ui-field01 read-only:text-text-secondary read-only:hover:ring-border-primary read-only:focus-visible:ring read-only:focus-visible:ring-border-primary read-only:focus-visible:outline-none disabled:bg-action-disabledBackground disabled:text-text-disabled02 disabled:ring-border-disabled disabled:placeholder:text-action-disabled01 disabled:focus-visible:ring disabled:focus-visible:outline-none',
  {
    variants: {
      color: {
        default:
          'ring ring-border-primary hover:ring-action-focusBorder focus:ring-2 focus:ring-action-focusBorder focus:ring-offset-0 hover:focus:border-none focus-visible:ring-2 focus-visible:ring-action-focusBorder focus-visible:ring-offset-0',
        warning:
          'ring-2 ring-warning-main focus-visible:ring-warning-main focus-visible:ring-offset-0',
        error:
          'ring-2 ring-error-main focus-visible:ring-error-main focus-visible:ring-offset-0',
      },
    },
    defaultVariants: {
      color: 'default',
    },
  },
);
